<template>
  <div class="main">

    <!-- Section Special Offers -->
    <section id="daydish" class="padd-100">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="offer-left">
              <span class="section-suptitle">{{dayDish.date}}</span>
              <h2 class="section-title">{{dayDish.title}}</h2>
              <div v-for="(dish, index) in dayDish.menu" class="offer-item daydish">
                <div>
                  <p>{{ dish.day }}</p>
                  <h3>{{ dish.dish }}</h3>
                </div>
              </div>
            </div>
            <p class="daydish info">* {{dayDish.info}}</p>
          </div>
          <div class="col-md-6 hidden-sm hidden-xs">
            <div class="offer-right">
              <img src="static/img/bg/meals.svg" alt="" class="img-responsive">
              <a href="#/menu">
                Nos mets
                <span>à emporter</span>
              </a>
              <a class="uber" href="https://www.ubereats.com/ch/store/la-pizzetta/Snc5SHZ5SJ2AUr5MTHHiKQ" target="_blank">
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Section Special Offers -->

    <!-- Section Reservation -->
    <section v-if="!isMobile()" id="deco" data-background="static/img/bg/outdor.jpg" class="parallax-window"></section>
    <!-- End Section Reservation -->
  </div>
    <!-- End Section Contact -->
</template>

<script>
  import menuData from "../data/menu.json";
  import dayDish from "../data/daydish.json";
export default {
  name: 'main',
  data () {
    return {
      dayDish: dayDish,
      menuData: menuData,
      randMenu: menuData.pizzas.slice().sort( function() { return 0.5 - Math.random() } ).splice(0, 3).sort( function(a, b) { return a.price > b.price }),
      isMobile: function(a){ return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())}
    }
  },
  mounted: function () {
    if(!this.isMobile()) {
      $('.parallax-window').each(function () {
        $(this).parallax($.extend(true, {
          lazyLoad: true,
          mode: 'parallax',
          speedFactor: 0.3
        }, $(this).data()));
      });
    }

    if($(window).scrollTop() > 100) {
      $('html,body').animate({scrollTop: 0}, 1500, 'easeInOutQuad');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// Main.vue?14a14aa0